<template>
  <RF-Dialog
  :cpntLargura='"450px"'
  :cpntStatus='statusGeral'
  :cpntTitulo="'Detalhe de custo do produto'"
  :cpntOnFecharDialog='proDetalheCustoFechar'>
    <template slot='conteudo'>
      <!-- ({{  cpntDetalhe }}) -->
      <!-- (({{  linhas }})) -->
      <div v-if="[ '', null, undefined ].indexOf(linhas) === -1" class="pro-detalhe">
        <table class="cpnt-tabela">
          <thead>
            <tr>
              <th v-if="cpntSimulacao === false">Rastreio Saída</th>
              <th>Rastreio Entrada</th>
              <th>Custo Uni.</th>
              <th>Qtde</th>
              <th>Custo Total</th>
            </tr>
          </thead>

          <tbody>
            <template v-for="(venda, index) in linhas">
              <tr :key="'tr1-' + index">
                <td :rowspan="venda.linhas.length" class="col_origem" v-if="cpntSimulacao === false">
                  <div><span>
                    <App-Button v-if="[ '', null, undefined ].indexOf(venda.cod_or) === -1" @onClick="proDetalheCustoAbrirTela('cod_or', venda.cod_or)"
                    :cpntTexto='"V" + (venda.cod_or.length <= 4 ? ("0000" + venda.cod_or).slice(-4) : venda.cod_or)'
                    :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                    ></App-Button>
                    <App-Button v-else-if="[ '', null, undefined ].indexOf(venda.cod_venda) === -1" @onClick="proDetalheCustoAbrirTela('cod_venda', venda.cod_venda)"
                    :cpntTexto='"V" + (venda.cod_venda.length <= 4 ? ("0000" + venda.cod_venda).slice(-4) : venda.cod_venda)'
                    :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                    ></App-Button>
                    <App-Button v-else-if="[ '', null, undefined ].indexOf(venda.id_produto_fabricado) === -1" @onClick="proDetalheCustoAbrirTela('id_produto_fabricado', venda.id_produto_fabricado)"
                    :cpntTexto='"F" + (venda.id_produto_fabricado.length <= 4 ? ("0000" + venda.id_produto_fabricado).slice(-4) : venda.id_produto_fabricado)'
                    :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                    ></App-Button>
                  </span></div>
                </td>

                <template v-if="venda.linhas !== undefined && venda.linhas.length >= 1">
                  <td class="col_demanda">
                    <div><span>
                      <template v-if="venda.linhas[0]._tipo === 'produto_estoque_nao_encontrado'">
                        <App-Icone :cpntTipo="'alerta-amarelo'" :cpntExplica="{ mensagem: 'Quantidade não encontrada em estoque por isso foi utilizado o Valor do Fornecedor do cadastro do Produto.' }"></App-Icone>
                      </template>
                      <template v-else-if="[ '', null, undefined ].indexOf(venda.linhas[0].qtde_ini) === -1">
                        Qtde Inicial
                      </template>
                      <template v-else-if="[ '', null, undefined ].indexOf(venda.linhas[0].estoque_ajuste) === -1">
                        Qtde Estoque Ajuste (Cód: {{ venda.linhas[0].id }})
                      </template>
                      <template v-else-if="venda.linhas[0]._tipo === 'produto_fabricado_na_venda'">
                        <div style="width: 65px; display: inline-block; vertical-align: -8px;">
                          Fabricado nesta Venda
                        </div>
                        <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm', 'fabricacao' ]" @onClick="() => { consumo = venda.linhas[0].id_ven_pro }">
                          <App-Icone :cpntTipo="'insumo'"></App-Icone>
                        </App-Button>
                      </template>
                      <template v-else-if="[ '', null, undefined ].indexOf(venda.linhas[0].id_produto_fabricado) === -1">
                        <App-Button @onClick="proDetalheCustoAbrirTela('id_produto_fabricado', venda.linhas[0].id_produto_fabricado)"
                        :cpntTexto='"F" + (venda.linhas[0].id_produto_fabricado.length <= 4 ? ("0000" + venda.linhas[0].id_produto_fabricado).slice(-4) : venda.linhas[0].id_produto_fabricado)'
                        :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                        ></App-Button>

                        <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm', 'fabricacao' ]" @onClick="() => { proDetalheSetarRelatorioConsumo(venda.linhas[0].id_produto_fabricado) }">
                          <App-Icone :cpntTipo="'insumo'"></App-Icone>
                        </App-Button>
                      </template>
                      <App-Button v-else-if="[ '', null, undefined ].indexOf(venda.linhas[0].dem_compra) === -1" @onClick="proDetalheCustoAbrirTela('dem_compra', venda.linhas[0].dem_compra)"
                      :cpntTexto='"C" + (venda.linhas[0].dem_compra.length <= 4 ? ("0000" + venda.linhas[0].dem_compra).slice(-4) : venda.linhas[0].dem_compra)'
                      :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                      ></App-Button>
                      <App-Button v-else-if="[ '', null, undefined ].indexOf(venda.linhas[0].dem_dev_cliente) === -1" @onClick="proDetalheCustoAbrirTela('dem_dev_cliente', venda.linhas[0].dem_dev_cliente)"
                      :cpntTexto='"DC" + (venda.linhas[0].dem_dev_cliente.length <= 4 ? ("0000" + venda.linhas[0].dem_dev_cliente).slice(-4) : venda.linhas[0].dem_dev_cliente)'
                      :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                      ></App-Button>
                      <App-Button v-else-if="[ '', null, undefined ].indexOf(venda.linhas[0].dem_dev_fornecedor) === -1" @onClick="proDetalheCustoAbrirTela('dem_dev_fornecedor', venda.linhas[0].dem_dev_fornecedor)"
                      :cpntTexto='"DF" + (venda.linhas[0].dem_dev_fornecedor.length <= 4 ? ("0000" + venda.linhas[0].dem_dev_fornecedor).slice(-4) : venda.linhas[0].dem_dev_fornecedor)'
                      :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                      ></App-Button>
                      <App-Button v-else-if="[ '', null, undefined ].indexOf(venda.linhas[0].cod_or) === -1" @onClick="proDetalheCustoAbrirTela('cod_or', venda.linhas[0].cod_or)"
                      :cpntTexto='"V" + (venda.linhas[0].cod_or.length <= 4 ? ("0000" + venda.linhas[0].cod_or).slice(-4) : venda.linhas[0].cod_or)'
                      :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                      ></App-Button>
                      <App-Button v-else-if="[ '', null, undefined ].indexOf(venda.linhas[0].cod_venda) === -1" @onClick="proDetalheCustoAbrirTela('cod_venda', venda.linhas[0].cod_venda)"
                      :cpntTexto='"V" + (venda.linhas[0].cod_venda.length <= 4 ? ("0000" + venda.linhas[0].cod_venda).slice(-4) : venda.linhas[0].cod_venda)'
                      :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                      ></App-Button>
                    </span></div>
                  </td>
                  <td>
                    <div><span>
                      {{ $store.state.FUN_MASK_VALOR('valorMoeda', (Number(venda.linhas[0].custo_unitario) * 100).toFixed(0)) }}
                    </span></div>
                  </td>
                  <td>
                    <div><span>
                      <span v-if="venda.linhas[0]._tipo === 'produto_fabricado_na_venda'" v-html="venda.linhas[0].qtde"></span>
                      <span v-else v-html="$store.state.FUN_MASK_VALOR('valorDecimal', venda.linhas[0].qtde)"></span>
                    </span></div>
                  </td>
                  <td>
                    <div><span>
                      <!-- ({{ venda.linhas[0] }}) -->
                      <!-- {{ $store.state.FUN_MASK_VALOR('valorMoeda', (Number(venda.linhas[0].custo_total) * 100).toFixed(0)) }} -->
                      {{ proDetalheCustoFormatarValor(venda.linhas[0].custo_total, false) }}
                    </span></div>
                  </td>
                </template>
              </tr>
              
              <template v-if="venda.linhas !== undefined && venda.linhas.length >= 2" v-for="(linha, indexL) in venda.linhas">
                <tr v-if="indexL !== 0" :key="'tr2-' + indexL">
                  <td class="col_demanda">
                    <div><span>
                      <template v-if="linha._tipo === 'produto_estoque_nao_encontrado'">
                        <App-Icone :cpntTipo="'alerta-amarelo'" :cpntExplica="{ mensagem: 'Quantidade não encontrada em estoque por isso foi utilizado o Valor do Fornecedor do cadastro do Produto.' }"></App-Icone>
                      </template>
                      <template v-else-if="[ '', null, undefined ].indexOf(linha.qtde_ini) === -1">
                        Qtde Inicial
                      </template>
                      <template v-else-if="[ '', null, undefined ].indexOf(linha.estoque_ajuste) === -1">
                        Qtde Estoque Ajuste (Cód: {{ linha.id }})
                      </template>
                      <template v-else-if="linha._tipo === 'produto_fabricado_na_venda'">
                        <div style="width: 65px; display: inline-block; vertical-align: -8px;">
                          Fabricado nesta Venda
                        </div>
                        <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm', 'fabricacao' ]" @onClick="() => { consumo = linha.id_ven_pro }">
                          <App-Icone :cpntTipo="'insumo'"></App-Icone>
                        </App-Button>
                      </template>
                      <App-Button v-else-if="linha._tipo === 'produto_fabricado_na_venda'" :cpntClass="[ 'btn', 'btn-default', 'btn-sm', 'fabricacao' ]" @onClick="() => { consumo = linha.id_ven_pro }">
                        <App-Icone :cpntTipo="'insumo'"></App-Icone>
                      </App-Button>
                      <template v-else-if="[ '', null, undefined ].indexOf(linha.id_produto_fabricado) === -1">
                        <App-Button @onClick="proDetalheCustoAbrirTela('id_produto_fabricado', linha.id_produto_fabricado)"
                        :cpntTexto='"F" + (linha.id_produto_fabricado.length <= 4 ? ("0000" + linha.id_produto_fabricado).slice(-4) : linha.id_produto_fabricado)'
                        :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                        ></App-Button>

                        <App-Button :cpntClass="[ 'btn', 'btn-default', 'btn-sm', 'fabricacao' ]" @onClick="() => { proDetalheSetarRelatorioConsumo(linha.id_produto_fabricado) }">
                          <App-Icone :cpntTipo="'insumo'"></App-Icone>
                        </App-Button>
                      </template>
                      <App-Button v-else-if="[ '', null, undefined ].indexOf(linha.dem_compra) === -1" @onClick="proDetalheCustoAbrirTela('dem_compra', linha.dem_compra)"
                      :cpntTexto='"C" + (linha.dem_compra.length <= 4 ? ("0000" + linha.dem_compra).slice(-4) : linha.dem_compra)'
                      :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                      ></App-Button>
                      <App-Button v-else-if="[ '', null, undefined ].indexOf(linha.dem_dev_cliente) === -1" @onClick="proDetalheCustoAbrirTela('dem_dev_cliente', linha.dem_dev_cliente)"
                      :cpntTexto='"DC" + (linha.dem_dev_cliente.length <= 4 ? ("0000" + linha.dem_dev_cliente).slice(-4) : linha.dem_dev_cliente)'
                      :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                      ></App-Button>
                      <App-Button v-else-if="[ '', null, undefined ].indexOf(linha.dem_dev_fornecedor) === -1" @onClick="proDetalheCustoAbrirTela('dem_dev_fornecedor', linha.dem_dev_fornecedor)"
                      :cpntTexto='"DF" + (linha.dem_dev_fornecedor.length <= 4 ? ("0000" + linha.dem_dev_fornecedor).slice(-4) : linha.dem_dev_fornecedor)'
                      :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                      ></App-Button>
                      <App-Button v-else-if="[ '', null, undefined ].indexOf(linha.cod_or) === -1" @onClick="proDetalheCustoAbrirTela('cod_or', linha.cod_or)"
                      :cpntTexto='"V" + (linha.cod_or.length <= 4 ? ("0000" + linha.cod_or).slice(-4) : linha.cod_or)'
                      :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                      ></App-Button>
                      <App-Button v-else-if="[ '', null, undefined ].indexOf(linha.cod_venda) === -1" @onClick="proDetalheCustoAbrirTela('cod_venda', linha.cod_venda)"
                      :cpntTexto='"V" + (linha.cod_venda.length <= 4 ? ("0000" + linha.cod_venda).slice(-4) : linha.cod_venda)'
                      :cpntClass="[ 'btn', 'btn-sm', 'btn-primary' ]"
                      ></App-Button>
                    </span></div>
                  </td>
                  <td>
                    <div><span>
                      {{ $store.state.FUN_MASK_VALOR('valorMoeda', (Number(linha.custo_unitario) * 100).toFixed(0)) }}
                    </span></div>
                  </td>
                  <td>
                    <div><span>
                      <span v-if="linha._tipo === 'produto_fabricado_na_venda'" v-html="linha.qtde"></span>
                      <span v-else v-html="$store.state.FUN_MASK_VALOR('valorDecimal', linha.qtde)"></span>
                    </span></div>
                  </td>
                  <td>
                    <div><span>
                      {{ proDetalheCustoFormatarValor(linha.custo_total, false) }}
                      <!-- ({{ linha }}) -->
                      <!-- {{ $store.state.FUN_MASK_VALOR('valorMoeda', (Number(linha.custo_total) * 100).toFixed(0)) }} -->
                    </span></div>
                  </td>
                </tr>
              </template>
            </template>
            
            <tr v-if="linhas.length === 0">
              <td :colspan="cpntSimulacao === false ? 5 : 4" style="text-align: center">
                Nenhum registro encontrado
              </td>
            </tr>

            <tr class="total" v-else>
              <!-- ({{ cpntSimulacao }}) -->
              <td :colspan="cpntSimulacao === false ? 2 : 1">
                &nbsp;
              </td>
              <td style="text-align: center">
                Total
              </td>
              <td>
                <span style="display: initial;" v-if="cpntDetalhe.qtde_vendida !== undefined" v-html="$store.state.FUN_MASK_VALOR('valorDecimal', cpntDetalhe.qtde_vendida)"></span>
                <span style="display: initial;" v-else-if="cpntDetalhe.estoque !== undefined" v-html="$store.state.FUN_MASK_VALOR('valorDecimal', cpntDetalhe.estoque)"></span>
                <span style="display: initial;" v-else-if="cpntDetalhe.qtde !== undefined" v-html="$store.state.FUN_MASK_VALOR('valorDecimal', cpntDetalhe.qtde)"></span>
              </td>
              <td>
                <!-- <span style="display: initial;" v-if="cpntDetalhe.custo_total !== undefined" v-html="$store.state.FUN_MASK_VALOR('valorMoeda', (Number(cpntDetalhe.custo_total) * 100).toFixed(0))"></span> -->
                <span style="display: initial;" v-if="cpntDetalhe.custo_total !== undefined" v-html="proDetalheCustoFormatarValor(cpntDetalhe.custo_total, false)"></span>
                <!-- <span style="display: initial;" v-else-if="cpntDetalhe.custo_historico_por_produto !== undefined && cpntDetalhe.custo_historico_por_produto[0] !== undefined && cpntDetalhe.custo_historico_por_produto[0].custo_total !== undefined" v-html="$store.state.FUN_MASK_VALOR('valorMoeda', (Number(cpntDetalhe.custo_historico_por_produto[0].custo_total) * 100).toFixed(0))"></span> -->
                <!-- {{ proDetalheCustoFormatarValor(cpntDetalhe.custo_total, false) }} -->
                <span style="display: initial;" v-else-if="cpntDetalhe.custo_historico_por_produto !== undefined && cpntDetalhe.custo_historico_por_produto[0] !== undefined && cpntDetalhe.custo_historico_por_produto[0].custo_total !== undefined" v-html="proDetalheCustoFormatarValor(cpntDetalhe.custo_historico_por_produto[0].custo_total, false)"></span>
                <!-- ({{ cpntDetalhe }}) -->
              </td>
            </tr>
          </tbody>
        </table>

        <!-- <br/>
        <br/>
        <br/>
        ({{ cpntDetalhe }}) -->
        <!-- ({{ consumo }}) -->
      </div>

      <App-Produto-Fabricado-Consumo v-if="consumo !== null"
      :cpntDados="typeof consumo === 'object' ? consumo : cpntDetalhe"
      :cpntFecharFormulario="() => { consumo = null }"
      ></App-Produto-Fabricado-Consumo>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.pro-det-titulo {
  margin-bottom: 10px;
}
  .pro-det-titulo > div > .titulo {
    margin-bottom: bold;
  }

.pro-detalhe > table {
  width: 100%;
  margin-bottom: 10px;
}
.pro-detalhe > table > tbody > tr > td:first-child[rowspan] {
  border: 1px solid #d5dee5;

}
.pro-detalhe > table > tbody > tr > td.col_origem {
  width: 75px;
  height: 40px;
}
.pro-detalhe > table > tbody > tr > td.col_demanda {
  width: 115px;
  height: 40px;
}
  
.pro-detalhe > table > tbody > tr.total > td {
  font-weight: bold;
  vertical-align: middle;
}

.pro-detalhe > table > tbody > tr > td.col_demanda > div > span > .fabricacao {
  margin: 2px 2px 2px 4px;
}
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntDetalhe: {
        required: false,
        type: Object
      },
      cpntSimulacao: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },

      cpntFecharFormulario: {
        required: true
      }
    },
    components: {
      'App-Produto-Fabricado-Consumo': () => import('@/components/produto/fabricado/Produto-Fabricado-Consumo.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        consumo: null,
        colunas: [
          { mPer: 3,    chave: 'demanda',          nome: 'Demanda' },
          { mPer: 3,    chave: 'qtde',             nome: 'Qtde' },
          { mPer: 3,    chave: 'custo_unitario',   nome: 'Custo Unitário' },
          // { mPer: 3,    chave: 'custo_total',   nome: 'linha' }
        ],
        linhas: ''
      }
    },
    mounted: function () {
      this.proDetalheCustoIniciar()
    },
    methods: {
      proDetalheCustoFechar: function (atualizar = false) {
        this.cpntFecharFormulario(atualizar)
      },
      proDetalheCustoIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.proDetalheCustoSetarStatusGeral('carregando')

        // TRATA O VETOR
        this.proDetalheCustoTratarValores()

        // SETA O STATUS DA PAGINA
        this.proDetalheCustoSetarStatusGeral('')
      },
      proDetalheCustoSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proDetalheCustoTratarValores: function () {
        // INICIA A VARIAVEL
        var linhas = []

        // PEGA O VETOR RECEBIDO
        var vetor = JSON.parse(JSON.stringify(this.cpntDetalhe))

        // console.error(vetor)
        // SETA O VALOR DA CHAVE
        if (vetor.custo_historico_por_produto === undefined) {
          vetor = { custo_historico_por_produto: [ JSON.parse(JSON.stringify(this.cpntDetalhe)) ] }
        }
        // console.warn(vetor)
        
        // RODA O VETOR MONTANDO AS LINHAS
        for (var index in vetor.custo_historico_por_produto) {
          // INICIA O VETOR
          var linha = {}

          // SETA O VETOR
          linha = JSON.parse(JSON.stringify(vetor.custo_historico_por_produto[index]))

          // DELETA AS CHAVES QUE NÃO SERÁ UTILIZADO
          delete linha.produto_fabricado_na_venda
          delete linha.produto_estoque_disponivel
          delete linha.produto_estoque_nao_encontrado

          // SETA OS VALORES
          linha = JSON.parse(JSON.stringify(linha))

          // INICIA A VARIAVEL
          linha.linhas = []

          // ADICIONA A CHAVE SOLICITADA
          if ([ '', null, undefined ].indexOf(vetor.custo_historico_por_produto[index].produto_estoque_disponivel) === -1) {
            for (var index1 in vetor.custo_historico_por_produto[index].produto_estoque_disponivel) {
              vetor.custo_historico_por_produto[index].produto_estoque_disponivel[index1]._tipo = 'produto_estoque_disponivel'
              // console.warn('VERIFICAR LINHA ABAIXO DEVE SER CALCULADA', JSON.parse(JSON.stringify(vetor.custo_historico_por_produto[index].produto_estoque_disponivel[index1])))
              // vetor.custo_historico_por_produto[index].produto_estoque_disponivel[index1].custo_total = (Number(vetor.custo_historico_por_produto[index].produto_estoque_disponivel[index1].qtde) * Number(vetor.custo_historico_por_produto[index].produto_estoque_disponivel[index1].custo_unitario))
            }
            linha.linhas = linha.linhas.concat(vetor.custo_historico_por_produto[index].produto_estoque_disponivel)
          }

          // ADICIONA A CHAVE SOLICITADA
          if ([ '', null, undefined ].indexOf(vetor.custo_historico_por_produto[index].produto_fabricado_na_venda) === -1) {
            // CONVERTE A CHAVE NO ARRAY
            if (Array.isArray(vetor.custo_historico_por_produto[index].produto_fabricado_na_venda) === false) {
              vetor.custo_historico_por_produto[index].produto_fabricado_na_venda = [ vetor.custo_historico_por_produto[index].produto_fabricado_na_venda ]
            }

            // TRATA OS VALORES RECEBIDOS
            for (var index2 in vetor.custo_historico_por_produto[index].produto_fabricado_na_venda) {
              vetor.custo_historico_por_produto[index].produto_fabricado_na_venda[index2]._tipo = 'produto_fabricado_na_venda'
              // console.error(JSON.parse(JSON.stringify(vetor.custo_historico_por_produto[index].produto_fabricado_na_venda[index2])))
              if (vetor.custo_historico_por_produto[index].produto_fabricado_na_venda[index2].qtde === undefined) {
                vetor.custo_historico_por_produto[index].produto_fabricado_na_venda[index2].qtde = '---'
              }
              if (vetor.custo_historico_por_produto[index].produto_fabricado_na_venda[index2].custo_unitario === undefined) {
                vetor.custo_historico_por_produto[index].produto_fabricado_na_venda[index2].custo_unitario = '---'
              }
              if (vetor.custo_historico_por_produto[index].produto_fabricado_na_venda[index2].custo_total === undefined) {
                vetor.custo_historico_por_produto[index].produto_fabricado_na_venda[index2].custo_total = vetor.custo_historico_por_produto[index].custo_total
              }
              linha.linhas = linha.linhas.concat([ vetor.custo_historico_por_produto[index].produto_fabricado_na_venda[index2] ])
            }
          }
          
          // SETA A CHAVE NO VETOR
          if ([ '', null, undefined ].indexOf(vetor.custo_historico_por_produto[index].produto_estoque_nao_encontrado) === -1) {
            vetor.custo_historico_por_produto[index].produto_estoque_nao_encontrado._tipo = 'produto_estoque_nao_encontrado'
            if (vetor.custo_historico_por_produto[index].produto_estoque_nao_encontrado.custo_total === undefined) {
              vetor.custo_historico_por_produto[index].produto_estoque_nao_encontrado.custo_total = vetor.custo_historico_por_produto[index].custo_total
            }
            linha.linhas = linha.linhas.concat([ vetor.custo_historico_por_produto[index].produto_estoque_nao_encontrado ])
          }

          // ADICIONA AS VARIAVEIS AO VETOR
          linhas.push(JSON.parse(JSON.stringify(linha)))
        }

        // SETA O VALOR MONTADO
        this.linhas = linhas.filter(item => item.linhas.length >= 1)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proDetalheCustoAbrirTela: function (tipo, valor) {
        // INICIA A VARIAVEL PARAMETRO
        var params = { name: '', params: { cts: this.$store.state.token.cts, id: valor, busca: { id: valor } } }

        // VERIFICA O TIPO DE REGISTRO
        switch (tipo) {
          case 'cod_or':
            params.name = 'venda_numero'
            break

          case 'dem_compra':
            params.name = 'compra_numero'
            break

          case 'id_produto_fabricado':
            params.params.busca = window.btoa(JSON.stringify(params.params.busca))
            params.name = 'prod_fabricar_busc'
            break
        }

        // MANDA ABRIR A TELA SOLICITADA
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve(params).href, '_blank')
      },
      proDetalheCustoFormatarValor: function (value, sifra = true) {
        // INICIA O VALOR
        var valor = '0,00'

        // FORMATA O VALOR SOLICITADO
        if ([ '', null, undefined ].indexOf(value) === -1) {
          valor = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', value)
        }

        // RETORNA O VALOR CALCULADO
        return (sifra === true ? 'R$ ' : '') + valor
      },
      proDetalheSetarRelatorioConsumo: function (consumo) {
        if (consumo !== null) {
          // INICIA O QUERYGET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE CARREGAR
          queryGet.field = {
            id: null,
            id_pro: { j: { nome: null, status: null, id_uni: null } },
            qtde_fabricada: null,
            data_fabricacao: null,
            obs: null,
            last_at: null,
            last_user: { j: { usuario: null } }
          }

          // SETA O FIELD VIRTUAL QUE DEVE BUSCAR
          queryGet.field_virtual = [ 'custo_historico' ]

          // SETA OS DADOS DO CONSUMO
          queryGet.where = { aAnd: [ { f: 'id', o: '=', v: consumo } ] }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/produto/fabricado/get', 'POST', queryGet, (retorno) => {
            // SETA O VALOR RECEBIDO
            retorno.data[0].qtde = retorno.data[0].qtde_fabricada

            // SETA O STATUS DA TELA
            this.consumo = retorno.data[0]
    
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.proDetalheCustoSetarStatusGeral)
        } else {
          // SETA O STATUS DA TELA
          this.consumo = consumo
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }        
      },
    }
  }
</script>
